import {Link, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {useUser} from "../../../contexts/UserContext";
import {useModal} from "../../../contexts/ModalContext";
import AxiosConfig from "../../../services/AxiosConfig";
import styles from "../../../pages/Admin/Admin.module.css";
import ContratsTable from "./ContratsTable";
import {fetchGetContrats, fetchToSetContratActif, setContratActif} from "../../../services/EntrepriseService";
import {fetchToSetUtilisateurActif} from "../../../services/UserService";
import {fetchToGetActivitesAdmin} from "../../../services/ActivitesService";

function ContratsVue({ entrepriseId }) {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    useEffect(() => {
        getContrats();
    }, [user]);

    const getContrats = async () => {
        const response = await fetchGetContrats(entrepriseId);
        if (!response.success) {
            handleError(response.message);
            return;
        }
        setMyApiData(response.data);
    }

    const putActifOpenModal = (contrat) => {
        const text = contrat.actif ? "supprimer" :  "activer";
        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} ce contrat ?`,
            onConfirm: async () => {
                const response = await fetchToSetContratActif(contrat);
                if (response.success) {
                    handleSuccess(response.message);
                } else {
                    handleError(response.message);
                }
                setTimeout(() => {
                    getContrats(contrat);
                }, 500);
            }
        });
    }

    const handleSubmitContratStatus = async (values, {setSubmitting}) => {
        try {
            const response = await AxiosConfig.post(`/admin/contrat/${values.id}/status`, values);
            if (response.data.success) {
                handleSuccess(response.data.message);
                setTimeout(() => {
                    getContrats();
                }, 500);
            } else {
                console.error('error', response.data);
                handleError("Erreur : " + response.data.message);
            }
        } catch (error) {
            console.error('error', error);
            handleError();
        }
    };

    return (
            <ContratsTable contrats={myApiData} putActifOpenModal={putActifOpenModal} handleSubmitContratStatus={handleSubmitContratStatus}/>
    )
}

export default ContratsVue;